import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";

/**
 * Gets all files from a DataTransfer object.
 *
 * @param {DataTransfer} dataTransfer DataTransfer object to inspect.
 *
 * @return {Object[]} An array containing all files.
 */
export function getFilesFromDataTransfer(dataTransfer) {
  var files = _toConsumableArray(dataTransfer.files);

  Array.from(dataTransfer.items).forEach(function (item) {
    var file = item.getAsFile();

    if (file && !files.find(function (_ref) {
      var name = _ref.name,
          type = _ref.type,
          size = _ref.size;
      return name === file.name && type === file.type && size === file.size;
    })) {
      files.push(file);
    }
  });
  return files;
}
//# sourceMappingURL=data-transfer.js.map